<template>
  <el-form
    size="small"
    label-position="top"
  >
    <el-row
      :gutter="15"
      class="mb-3"
    >
      <el-col :span="11">
        <el-row :gutter="15">
          <el-col :span="12">
            <!-- Account -->
            <el-card
              header="Customer"
              shadow="never"
              class="mb-3"
            >
              <el-form-item
                label="Account"
                :show-message="!pickup.$fields.account.valid"
                :error="pickup.$fields.account.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'account.name') || '-' }}
                </div>

                <el-autocomplete
                  v-else
                  v-model="accountInput"
                  :fetch-suggestions="accountQuerySearch"
                  :trigger-on-focus="false"
                  placeholder="Enter a keyword"
                  class="w-100"
                  :debounce="500"
                  value-key="name"
                  clearable
                  @select="handleSelectAccount"
                  @clear="clearAccountInput"
                />
              </el-form-item>

              <el-form-item
                label="Team"
                :show-message="!pickup.$fields.team.valid"
                :error="pickup.$fields.team.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'team.name') || '-' }}
                </div>
                <el-select
                  v-else
                  v-model="pickup.team"
                  placeholder="Select a team"
                  class="w-100"
                  value-key="id"
                  filterable
                  :loading="isLoadingTeams"
                  :disabled="!$_.get(pickup.account, 'id')"
                  @change="onTeamChanged"
                >
                  <el-option
                    v-for="team in teams"
                    :key="team.id"
                    :label="team.name"
                    :value="team"
                  />
                </el-select>
              </el-form-item>

              <el-form-item
                label="Caller Name"
                :show-message="!pickup.$fields.caller_name.valid"
                :error="pickup.$fields.caller_name.message"
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'caller_name') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.caller_name"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Caller Phone"
                :show-message="!pickup.$fields.caller_phone.valid"
                :error="pickup.$fields.caller_phone.message"
                class="mb-0"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'caller_phone') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.caller_phone"
                  clearable
                />
              </el-form-item>
            </el-card>

            <!-- Carrier -->
            <el-card
              header="Carrier"
              shadow="never"
            >
              <el-form-item
                v-if="pickup.status !== 'processed' && pickup.status !== 'confirmed'"
                label="Search Account Services"
                class="mb-2"
              >
                <el-select
                  v-model="carrierService"
                  placeholder=""
                  value-key="id"
                  filterable
                  :disabled="!pickup.account"
                  class="w-100"
                  @change="onCarrierAndServiceSelected"
                >
                  <el-option-group
                    v-for="(carriersAndServicesCarrierServices, carrierName) in carriersAndServices"
                    :key="carrierName"
                    :label="carrierName"
                  >
                    <el-option
                      v-for="cs in carriersAndServicesCarrierServices"
                      :key="cs.id"
                      :label="`${cs.name} ${carrierName}`"
                      :value="cs"
                    >
                      {{ cs.name }}
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>

              <el-divider v-if="pickup.status !== 'processed' && pickup.status !== 'confirmed'">
                or
              </el-divider>

              <el-form-item
                label="Carrier"
                :show-message="!pickup.$fields.carrier.valid || !pickup.$fields.status.valid"
                :error="pickup.$fields.carrier.message || pickup.$fields.status.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'carrier.name') || '-' }}
                </div>
                <el-select
                  v-else
                  v-model="pickup.carrier"
                  filterable
                  remote
                  value-key="id"
                  placeholder="Enter a keyword"
                  class="w-100"
                  :remote-method="remoteMethodCarrier"
                  :loading="isLoadingCarriers"
                  @change="onCarrierChanged"
                >
                  <el-option
                    v-for="item in carriers"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  />
                </el-select>
              </el-form-item>

              <el-form-item
                label="Service"
                :show-message="!pickup.$fields.carrier_service.valid"
                :error="pickup.$fields.carrier_service.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'carrier_service.name') || '-' }}
                </div>
                <el-select
                  v-else
                  v-model="pickup.carrier_service"
                  placeholder="Select a Carrier Serivce"
                  class="w-100"
                  value-key="id"
                  :disabled="!$_.get(pickup.carrier, 'id')"
                  :loading="isLoadingCarrierServices"
                  filterable
                  @change="onCarrierServiceChanged"
                >
                  <el-option
                    v-for="service in carrierServices"
                    :key="service.id"
                    :label="service.name"
                    :value="service"
                  />
                </el-select>
              </el-form-item>

              <el-form-item
                label="Charge Account"
                :show-message="!pickup.$fields.charge_account.valid"
                :error="pickup.$fields.charge_account.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'charge_account') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.charge_account"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Carrier Cutoff Time"
                :show-message="!pickup.$fields.carrier_cut_off_time.valid"
                :error="pickup.$fields.carrier_cut_off_time.message"
                class="mb-0"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'carrier_cut_off_time') ? $moment($_.get(pickup, 'carrier_cut_off_time'), 'HH:mm:ss').format('hh:mm A') : '-' }}
                </div>
                <el-time-picker
                  v-else
                  v-model="pickup.carrier_cut_off_time"
                  class="w-100"
                  format="HH:mm"
                  value-format="HH:mm"
                  :picker-options="{ format: 'HH:mm' }"
                />
              </el-form-item>
            </el-card>
          </el-col>

          <el-col :span="12">
            <!-- Details -->
            <el-card
              header="Details"
              shadow="never"
              class="mb-3"
            >
              <el-form-item
                v-show="!isScheduleTemplate && pickup.type !== 'scheduled'"
                label="Pickup Date"
                :show-message="!pickup.$fields.customer_pickup_date.valid"
                :error="pickup.$fields.customer_pickup_date.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'customer_pickup_date') ? $moment($_.get(pickup, 'customer_pickup_date')).format('DD/MM/YYYY') : '-' }}
                </div>
                <el-date-picker
                  v-else
                  v-model="pickup.customer_pickup_date"
                  type="date"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  class="w-100"
                />
              </el-form-item>

              <el-form-item
                v-show="!isScheduleTemplate && pickup.type !== 'scheduled'"
                label="Ready At"
                :show-message="!pickup.$fields.customer_ready_time.valid"
                :error="pickup.$fields.customer_ready_time.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'customer_ready_time') ? $moment($_.get(pickup, 'customer_ready_time'), 'HH:mm:ss').format('hh:mm A') : '-' }}
                </div>
                <el-time-picker
                  v-else
                  v-model="pickup.customer_ready_time"
                  class="w-100"
                  format="HH:mm"
                  value-format="HH:mm"
                  :picker-options="{ format: 'HH:mm' }"
                />
              </el-form-item>

              <el-form-item
                v-show="!isScheduleTemplate && pickup.type !== 'scheduled'"
                label="Closing At"
                :show-message="!pickup.$fields.customer_closing_time.valid"
                :error="pickup.$fields.customer_closing_time.message"
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'customer_closing_time') ? $moment($_.get(pickup, 'customer_closing_time'), 'HH:mm:ss').format('hh:mm A') : '-' }}
                </div>
                <el-time-picker
                  v-else
                  v-model="pickup.customer_closing_time"
                  class="w-100"
                  format="HH:mm"
                  value-format="HH:mm"
                  :picker-options="{ format: 'HH:mm' }"
                />
              </el-form-item>

              <el-form-item
                label="Time Zone"
                :show-message="!pickup.$fields.customer_time_zone.valid"
                :error="pickup.$fields.customer_time_zone.message"
                required
                class="mb-0"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'customer_time_zone.zone') || '-' }}
                </div>
                <el-select
                  v-else
                  v-model="pickup.customer_time_zone"
                  placeholder="Select a Time Zone"
                  class="w-100"
                  value-key="id"
                  filterable
                  clearable
                  :disabled="isLoadingTimezones"
                >
                  <el-option
                    v-for="timezone in timezones"
                    :key="timezone.id"
                    :label="timezone.zone"
                    :value="timezone"
                  />
                </el-select>
              </el-form-item>
            </el-card>

            <!-- Reference -->
            <el-card
              header="Reference"
              shadow="never"
            >
              <el-form-item
                label="Collection Name"
                :show-message="!pickup.$fields.collection_name.valid"
                :error="pickup.$fields.collection_name.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'collection_name') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.collection_name"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Cost Centre"
                :show-message="!pickup.$fields.cost_centre.valid"
                :error="pickup.$fields.cost_centre.message"
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'cost_centre') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.cost_centre"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Carrier Reference"
                :show-message="!pickup.$fields.carrier_reference.valid"
                :error="pickup.$fields.carrier_reference.message"
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'carrier_reference') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.carrier_reference"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Customer Reference"
                :show-message="!pickup.$fields.customer_reference.valid"
                :error="pickup.$fields.customer_reference.message"
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'customer_reference') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.customer_reference"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Special Instructions"
                :show-message="!pickup.$fields.special_instructions.valid"
                :error="pickup.$fields.special_instructions.message"
                class="mb-0"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'special_instructions') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.special_instructions"
                  type="textarea"
                  :rows="2"
                  clearable
                />
              </el-form-item>
            </el-card>
          </el-col>
        </el-row>
      </el-col>

      <el-col :span="13">
        <el-row :gutter="15">
          <el-col :span="12">
            <!-- Sender -->
            <el-card shadow="never">
              <div slot="header">
                <span>Sender</span>
                <el-button
                  v-if="pickup.status !== 'processed' && pickup.status !== 'confirmed'"
                  type="text"
                  @click.native="swapSenderReceiver"
                >
                  Swap Addressees
                </el-button>
              </div>

              <el-form-item
                v-if="pickup.status !== 'processed' && pickup.status !== 'confirmed'"
                label="Search Account Addresses"
                class="mb-2"
              >
                <el-autocomplete
                  v-model="senderAddressSearch"
                  :fetch-suggestions="addressQuerySearch"
                  :trigger-on-focus="false"
                  :disabled="!$_.get(pickup.account, 'id')"
                  clearable
                  class="w-100"
                  @select="handleSenderAddressSelect"
                >
                  <template v-slot="{ item }">
                    <p class="m-0 pt-2">
                      {{ item.name }}
                    </p>

                    <p class="m-0 pb-2 text-muted">
                      {{ item.line_one }}, {{ item.suburb }} {{ item.state }} {{ item.postcode }}
                    </p>
                  </template>
                </el-autocomplete>
              </el-form-item>

              <el-divider v-if="pickup.status !== 'processed' && pickup.status !== 'confirmed'">
                or
              </el-divider>

              <el-row
                :gutter="13"
                class="mb-2"
              >
                <el-col :span="12">
                  <el-form-item
                    label="First Name"
                    :show-message="!pickup.sender.$fields.first_name.valid"
                    :error="pickup.sender.$fields.first_name.message"
                    class="m-0"
                  >
                    <div
                      v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                      class="bg-lighter p-1"
                    >
                      {{ $_.get(pickup, 'sender.first_name') || '-' }}
                    </div>
                    <el-input
                      v-else
                      v-model="pickup.sender.first_name"
                      clearable
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item
                    label="Last Name"
                    :show-message="!pickup.sender.$fields.last_name.valid"
                    :error="pickup.sender.$fields.last_name.message"
                    class="m-0"
                  >
                    <div
                      v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                      class="bg-lighter p-1"
                    >
                      {{ $_.get(pickup, 'sender.last_name') || '-' }}
                    </div>
                    <el-input
                      v-else
                      v-model="pickup.sender.last_name"
                      clearable
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item
                label="Company"
                :show-message="!pickup.sender.$fields.organisation_name.valid"
                :error="pickup.sender.$fields.organisation_name.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'sender.organisation_name') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.sender.organisation_name"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Addr. Line One"
                :show-message="!pickup.sender.$fields.address_line1.valid"
                :error="pickup.sender.$fields.address_line1.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'sender.address_line1') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.sender.address_line1"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Addr. Line Two"
                :show-message="!pickup.sender.$fields.address_line2.valid"
                :error="pickup.sender.$fields.address_line2.message"
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'sender.address_line2') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.sender.address_line2"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Suburb"
                :show-message="!pickup.sender.$fields.locality.valid"
                :error="pickup.sender.$fields.locality.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'sender.locality') || '-' }}
                </div>
                <el-autocomplete
                  v-else
                  v-model="pickup.sender.locality"
                  prefix-icon="el-icon-search"
                  :fetch-suggestions="suburbSenderQuerySearch"
                  placeholder="Enter a keyword"
                  class="w-100"
                  :trigger-on-focus="false"
                  :popper-append-to-body="false"
                  clearable
                  @select="handleSenderSuburbSelect"
                >
                  <template v-slot="{ item }">
                    {{ `${item.suburb}, ${item.state} ${item.postcode}` }}
                  </template>
                </el-autocomplete>
              </el-form-item>

              <el-row
                :gutter="13"
                class="mb-2"
              >
                <el-col :span="8">
                  <el-form-item
                    label="State"
                    :show-message="!pickup.sender.$fields.administrative_area.valid"
                    :error="pickup.sender.$fields.administrative_area.message"
                    required
                    class="m-0"
                  >
                    <div
                      v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                      class="bg-lighter p-1"
                    >
                      {{ $_.get(pickup, 'sender.administrative_area') || '-' }}
                    </div>
                    <el-select
                      v-else
                      v-model="pickup.sender.administrative_area"
                      class="w-100"
                    >
                      <el-option
                        v-for="state in states"
                        :key="state.value"
                        :label="state.label"
                        :value="state.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    label="Postcode"
                    :show-message="!pickup.sender.$fields.postal_code.valid"
                    :error="pickup.sender.$fields.postal_code.message"
                    required
                    class="m-0"
                  >
                    <div
                      v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                      class="bg-lighter p-1"
                    >
                      {{ $_.get(pickup, 'sender.postal_code') || '-' }}
                    </div>
                    <el-input
                      v-else
                      v-model="pickup.sender.postal_code"
                      clearable
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    label="Country"
                    :show-message="!pickup.sender.$fields.country.valid"
                    :error="pickup.sender.$fields.country.message"
                    required
                    class="m-0"
                  >
                    <div
                      v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                      class="bg-lighter p-1"
                    >
                      {{ $_.get(pickup, 'sender.country') || '-' }}
                    </div>
                    <el-select
                      v-else
                      v-model="pickup.sender.country"
                      filterable
                      class="w-100"
                    >
                      <el-option
                        v-for="country in countries"
                        :key="country.iso"
                        :label="country.name"
                        :value="country.iso"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item
                label="Phone"
                :show-message="!pickup.sender.$fields.phone.valid"
                :error="pickup.sender.$fields.phone.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'sender.phone') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.sender.phone"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Email"
                :show-message="!pickup.sender.$fields.email.valid"
                :error="pickup.sender.$fields.email.message"
                class="mb-0"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'sender.email') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.sender.email"
                  clearable
                />
              </el-form-item>
            </el-card>
          </el-col>

          <el-col :span="12">
            <el-card shadow="never">
              <div slot="header">
                <span>Receiver</span>
                <el-button
                  v-if="pickup.status !== 'processed' && pickup.status !== 'confirmed'"
                  type="text"
                  @click.native="setVarious"
                >
                  Set Various
                </el-button>
              </div>

              <el-form-item
                v-if="pickup.status !== 'processed' && pickup.status !== 'confirmed'"
                label="Search Account Addresses"
                class="mb-2"
              >
                <el-autocomplete
                  v-model="receiverAddressSearch"
                  :fetch-suggestions="addressQuerySearch"
                  :trigger-on-focus="false"
                  :disabled="!$_.get(pickup.account, 'id')"
                  clearable
                  class="w-100"
                  @select="handleReceiverAddressSelect"
                >
                  <template v-slot="{ item }">
                    <p class="m-0 pt-2">
                      {{ item.name }}
                    </p>

                    <p class="m-0 pb-2 text-muted">
                      {{ item.line_one }}, {{ item.suburb }} {{ item.state }} {{ item.postcode }}
                    </p>
                  </template>
                </el-autocomplete>
              </el-form-item>

              <el-divider v-if="pickup.status !== 'processed' && pickup.status !== 'confirmed'">
                or
              </el-divider>

              <el-row
                :gutter="13"
                class="mb-2"
              >
                <el-col :span="12">
                  <el-form-item
                    label="First Name"
                    :show-message="!pickup.receiver.$fields.first_name.valid"
                    :error="pickup.receiver.$fields.first_name.message"
                    class="m-0"
                  >
                    <div
                      v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                      class="bg-lighter p-1"
                    >
                      {{ $_.get(pickup, 'receiver.first_name') || '-' }}
                    </div>
                    <el-input
                      v-else
                      v-model="pickup.receiver.first_name"
                      clearable
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item
                    label="Last Name"
                    :show-message="!pickup.receiver.$fields.last_name.valid"
                    :error="pickup.receiver.$fields.last_name.message"
                    class="m-0"
                  >
                    <div
                      v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                      class="bg-lighter p-1"
                    >
                      {{ $_.get(pickup, 'receiver.last_name') || '-' }}
                    </div>
                    <el-input
                      v-else
                      v-model="pickup.receiver.last_name"
                      clearable
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item
                label="Company"
                :show-message="!pickup.receiver.$fields.organisation_name.valid"
                :error="pickup.receiver.$fields.organisation_name.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'receiver.organisation_name') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.receiver.organisation_name"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Addr. Line One"
                :show-message="!pickup.receiver.$fields.address_line1.valid"
                :error="pickup.receiver.$fields.address_line1.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'receiver.address_line1') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.receiver.address_line1"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Addr. Line Two"
                :show-message="!pickup.receiver.$fields.address_line2.valid"
                :error="pickup.receiver.$fields.address_line2.message"
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'receiver.address_line2') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.receiver.address_line2"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Suburb"
                :show-message="!pickup.receiver.$fields.locality.valid"
                :error="pickup.receiver.$fields.locality.message"
                required
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'receiver.locality') || '-' }}
                </div>
                <el-autocomplete
                  v-else
                  v-model="pickup.receiver.locality"
                  prefix-icon="el-icon-search"
                  :fetch-suggestions="suburbReceiverQuerySearch"
                  placeholder="Enter a keyword"
                  class="w-100"
                  :trigger-on-focus="false"
                  :popper-append-to-body="false"
                  clearable
                  @select="handleReceiverSuburbSelect"
                >
                  <template v-slot="{ item }">
                    {{ `${item.suburb}, ${item.state}, ${item.postcode}` }}
                  </template>
                </el-autocomplete>
              </el-form-item>

              <el-row
                :gutter="13"
                class="mb-2"
              >
                <el-col :span="8">
                  <el-form-item
                    label="State"
                    :show-message="!pickup.receiver.$fields.administrative_area.valid"
                    :error="pickup.receiver.$fields.administrative_area.message"
                    required
                    class="m-0"
                  >
                    <div
                      v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                      class="bg-lighter p-1"
                    >
                      {{ $_.get(pickup, 'receiver.administrative_area') || '-' }}
                    </div>
                    <el-select
                      v-else
                      v-model="pickup.receiver.administrative_area"
                      class="w-100"
                    >
                      <el-option
                        v-for="state in states"
                        :key="state.value"
                        :label="state.label"
                        :value="state.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    label="Postcode"
                    :show-message="!pickup.receiver.$fields.postal_code.valid"
                    :error="pickup.receiver.$fields.postal_code.message"
                    required
                    class="m-0"
                  >
                    <div
                      v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                      class="bg-lighter p-1"
                    >
                      {{ $_.get(pickup, 'receiver.postal_code') || '-' }}
                    </div>
                    <el-input
                      v-else
                      v-model="pickup.receiver.postal_code"
                      clearable
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    label="Country"
                    :show-message="!pickup.receiver.$fields.country.valid"
                    :error="pickup.receiver.$fields.country.message"
                    required
                    class="m-0"
                    @select="handleReceiverCountryChange()"
                  >
                    <div
                      v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                      class="bg-lighter p-1"
                    >
                      {{ $_.get(pickup, 'receiver.country') || '-' }}
                    </div>

                    <el-select
                      v-else
                      v-model="pickup.receiver.country"
                      filterable
                      class="w-100"
                    >
                      <el-option
                        v-for="country in countries"
                        :key="country.iso"
                        :label="country.name"
                        :value="country.iso"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item
                label="Phone"
                :show-message="!pickup.receiver.$fields.phone.valid"
                :error="pickup.receiver.$fields.phone.message"
                class="mb-2"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'receiver.phone') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.receiver.phone"
                  clearable
                />
              </el-form-item>

              <el-form-item
                label="Email"
                :show-message="!pickup.receiver.$fields.email.valid"
                :error="pickup.receiver.$fields.email.message"
                class="mb-0"
              >
                <div
                  v-if="pickup.status === 'processed' || pickup.status === 'confirmed'"
                  class="bg-lighter p-1"
                >
                  {{ $_.get(pickup, 'receiver.email') || '-' }}
                </div>
                <el-input
                  v-else
                  v-model="pickup.receiver.email"
                  clearable
                />
              </el-form-item>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row :gutter="15">
      <!-- Consignments -->
      <el-col :span="6">
        <el-card
          header="Consignments"
          shadow="never"
        >
          <el-row>
            <el-col>
              <template v-if="isConsignmentMode">
                <div
                  v-for="(consignment, index) in pickup.consignments"
                  :key="`con_${index}`"
                >
                  <div class="consignments-container">
                    <template v-if="pickup.status === 'processed' || pickup.status === 'confirmed'">
                      <span>
                        <ConsignmentLink
                          :consignment="consignment"
                          target="_blank"
                        >
                          {{ consignment.con_full }}
                        </ConsignmentLink>{{ `, ${consignment.con_sender_name || '-'}, ${consignment.con_receiver_name || '-'}` }}
                      </span>
                      <el-divider v-if="index !== pickup.consignments.length - 1" />
                    </template>
                    <div
                      v-else
                      style="display: flex;"
                    >
                      <el-input
                        style="padding-right: 10px;"
                        :value="`${consignment.con_full || '-'}, ${consignment.con_sender_name || '-'}, ${consignment.con_receiver_name || '-'}`"
                        size="small"
                        :readonly="true"
                      />
                      <el-button
                        size="mini"
                        type="danger"
                        @click.native="removeConsignmentByIndex(index)"
                      >
                        Remove
                      </el-button>
                    </div>
                  </div>
                  <br>
                </div>

                <el-autocomplete
                  v-if="pickup.status !== 'processed' && pickup.status !== 'confirmed'"
                  v-model="newConsignmentInput"
                  :fetch-suggestions="consignmentQuerySearch"
                  placeholder="Enter a keyword"
                  class="w-100"
                  size="small"
                  :trigger-on-focus="false"
                  @select="handleSelectConsignment"
                >
                  <template v-slot="{ item }">
                    {{ `${item.con_full}, ${item.con_sender_name}` }}
                  </template>
                </el-autocomplete>
              </template>

              <template v-else>
                <template v-if="pickup.status === 'processed' || pickup.status === 'confirmed'">
                  <p>This pickup is not linking to any consignments</p>
                </template>
                <template v-else>
                  <p><i>Cannot add consignments while in <strong>[Item Mode]</strong></i></p>
                  <p><i><sup>*</sup>&nbsp;Remove all items to switch to <strong>[Consignment Mode]</strong></i></p>
                </template>
              </template>
            </el-col>
          </el-row>
        </el-card>
      </el-col>

      <!-- Items -->
      <el-col :span="18">
        <el-card shadow="never">
          <div slot="header">
            <span>Items</span>
            <el-button
              v-if="(isConsignmentMode && pickup.consignments.length > 0) && (pickup.status !== 'processed' && pickup.status !== 'confirmed')"
              type="text"
              @click.native="convertConsignmentItems"
            >
              Convert Consignment Items
            </el-button>

            <el-button
              v-else-if="(!isConsignmentMode || pickup.consignments.length === 0) && (pickup.status !== 'processed' && pickup.status !== 'confirmed')"
              type="text"
              @click.native="addNewItem"
            >
              Add Item
            </el-button>
          </div>

          <el-row>
            <el-col>
              <template v-if="isConsignmentMode">
                <div
                  v-for="(consignment, index) in pickup.consignments"
                  :key="`conitems_${index}`"
                >
                  <h2>
                    {{ consignment.con_full }}
                    {{ `${consignment.con_sender_name || '-'} - ${consignment.con_receiver_name || '-'}` }}
                  </h2>
                  <el-table
                    :data="consignment.items"
                    size="mini"
                    stripe
                    :border="true"
                  >
                    <el-table-column
                      label="Type"
                      :formatter="row => `${$_.get(row, 'type.desc') || '-'}, ${$_.get(row, 'type.edi')}`"
                    />

                    <el-table-column
                      label="Description"
                      :formatter="row => $_.get(row, 'item_desc') || '-'"
                    />

                    <el-table-column
                      label="Quantity"
                      :formatter="row => $_.get(row, 'item_qty') || '-'"
                    />

                    <el-table-column
                      label="Weight"
                      :formatter="row => $_.get(row, 'item_weight') || '-'"
                    />

                    <el-table-column
                      label="Length"
                      :formatter="row => $_.get(row, 'item_length') || '-'"
                    />

                    <el-table-column
                      label="Width"
                      :formatter="row => $_.get(row, 'item_width') || '-'"
                    />

                    <el-table-column
                      label="Height"
                      :formatter="row => $_.get(row, 'item_height') || '-'"
                    />
                  </el-table>
                  <br>
                </div>
              </template>

              <template v-else>
                <template v-if="pickup.status === 'processed' || pickup.status === 'confirmed'">
                  <el-table
                    :data="pickup.items"
                    size="mini"
                    stripe
                    :border="true"
                  >
                    <el-table-column
                      label="Type"
                      :formatter="row => `${$_.get(row, 'type.desc') || '-'}, ${$_.get(row, 'type.edi') || '-'}`"
                    />
                    <el-table-column
                      label="Description"
                      :formatter="row => $_.get(row, 'description') || '-'"
                    />
                    <el-table-column
                      label="Quantity"
                      :formatter="row => $_.get(row, 'item_count') || '-'"
                    />
                    <el-table-column
                      label="Weight"
                      :formatter="row => $_.get(row, 'weight') || '-'"
                    />
                    <el-table-column
                      label="Length"
                      :formatter="row => $_.get(row, 'length') || '-'"
                    />
                    <el-table-column
                      label="Width"
                      :formatter="row => $_.get(row, 'width') || '-'"
                    />
                    <el-table-column
                      label="Height"
                      :formatter="row => $_.get(row, 'height') || '-'"
                    />
                    <el-table-column
                      label="Dangerous"
                      :formatter="row => $_.get(row, 'is_dg') ? 'Yes' : 'No'"
                    />
                  </el-table>
                </template>
                <template v-else>
                  <el-row
                    :gutter="15"
                    class="mb-2"
                  >
                    <el-col class="one-ninth">
                      <p class="top-header-label">
                        Type
                      </p>
                    </el-col>

                    <el-col class="one-ninth">
                      <p class="top-header-label">
                        Description
                      </p>
                    </el-col>

                    <el-col class="one-ninth">
                      <p class="top-header-label">
                        Quantity
                      </p>
                    </el-col>

                    <el-col class="one-ninth">
                      <p class="top-header-label">
                        Weight
                      </p>
                    </el-col>

                    <el-col class="one-ninth">
                      <p class="top-header-label">
                        Length
                      </p>
                    </el-col>

                    <el-col class="one-ninth">
                      <p class="top-header-label">
                        Width
                      </p>
                    </el-col>

                    <el-col class="one-ninth">
                      <p class="top-header-label">
                        Height
                      </p>
                    </el-col>

                    <el-col class="one-ninth text-center">
                      <p class="top-header-label">
                        Dangerous
                      </p>
                    </el-col>

                    <el-col class="one-ninth">
                      <p class="top-header-label">
                        &nbsp;
                      </p>
                    </el-col>
                  </el-row>

                  <el-row
                    v-for="(item, index) in pickup.items"
                    :key="index"
                    :gutter="12"
                    type="flex"
                    align="middle"
                    class="items-container mb-2"
                  >
                    <el-col class="one-ninth">
                      <el-form-item
                        :show-message="item.$fields.type.valid"
                        :error="item.$fields.type.message"
                        class="m-0"
                      >
                        <el-select
                          v-model="item.type"
                          class="w-100"
                          value-key="id"
                          clearable
                          size="small"
                          :loading="isLoadingItemtypes"
                          @change="handleItemTypeSelection(item)"
                        >
                          <el-option
                            v-for="type in itemtypes"
                            :key="type.id"
                            :label="`${type.desc}, ${type.edi}`"
                            :value="type"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col class="one-ninth">
                      <el-form-item
                        :show-message="item.$fields.description.valid"
                        :error="item.$fields.description.message"
                        class="m-0"
                      >
                        <el-input
                          v-model="item.description"
                          size="small"
                          clearable
                        />
                      </el-form-item>
                    </el-col>

                    <el-col class="one-ninth">
                      <el-form-item
                        :show-message="item.$fields.item_count.valid"
                        :error="item.$fields.item_count.message"
                        class="m-0"
                      >
                        <el-input
                          v-model="item.item_count"
                          size="small"
                          clearable
                        />
                      </el-form-item>
                    </el-col>

                    <el-col class="one-ninth">
                      <el-form-item
                        :show-message="item.$fields.weight.valid"
                        :error="item.$fields.weight.message"
                        class="m-0"
                      >
                        <el-input
                          v-model="item.weight"
                          size="small"
                          clearable
                        />
                      </el-form-item>
                    </el-col>

                    <el-col class="one-ninth">
                      <el-form-item
                        :show-message="item.$fields.length.valid"
                        :error="item.$fields.length.message"
                        class="m-0"
                      >
                        <el-input
                          v-model="item.length"
                          size="small"
                          clearable
                        />
                      </el-form-item>
                    </el-col>

                    <el-col class="one-ninth">
                      <el-form-item
                        :show-message="item.$fields.width.valid"
                        :error="item.$fields.width.message"
                        class="m-0"
                      >
                        <el-input
                          v-model="item.width"
                          size="small"
                          clearable
                        />
                      </el-form-item>
                    </el-col>

                    <el-col class="one-ninth">
                      <el-form-item
                        :show-message="item.$fields.height.valid"
                        :error="item.$fields.height.message"
                        class="m-0"
                      >
                        <el-input
                          v-model="item.height"
                          size="small"
                          clearable
                        />
                      </el-form-item>
                    </el-col>

                    <el-col class="one-ninth text-center">
                      <el-switch v-model="item.is_dg" />
                    </el-col>

                    <el-col
                      class="one-ninth text-right align-baseline"
                    >
                      <el-button
                        size="mini"
                        type="danger"
                        @click.native="pickup.items.splice(index, 1)"
                      >
                        Remove
                      </el-button>
                    </el-col>
                  </el-row>
                </template>
              </template>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { statusAllows } from '@/components/Application/CustomerService/Pickups/Pickup/PickupFunctions'
import Filter, { IS, CONTAINS } from '@/plugins/sdk/Filter'
import ConsignmentLink from '@/components/Popovers/ConsignmentLink'

export default {
  components: {
    ConsignmentLink
  },
  props: {
    isScheduleTemplate: {
      type: Boolean,
      required: false,
      default: false
    },
    pickup: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      types: [
        { label: 'Permanent', value: 'permanent' },
        { label: 'Auto', value: 'auto' },
        { label: 'Ad hoc', value: 'adhoc' },
        { label: 'Scheduled', value: 'scheduled' },
        { label: 'Unknown', value: 'unknown' }
      ],
      states: [
        { label: 'ACT', value: 'ACT' },
        { label: 'NSW', value: 'NSW' },
        { label: 'NT', value: 'NT' },
        { label: 'QLD', value: 'QLD' },
        { label: 'SA', value: 'SA' },
        { label: 'TAS', value: 'TAS' },
        { label: 'VIC', value: 'VIC' },
        { label: 'WA', value: 'WA' },
        { label: 'Other', value: 'Other' }
      ],
      countries: [],
      isLoadingTeams: false,
      isLoadingCarriers: false,
      isLoadingCarrierServices: false,
      isLoadingTimezones: false,
      isLoadingItemtypes: false,
      currentStatus: null,
      accountInput: '',
      teams: [],
      carriers: [],
      carrierServices: [],
      carriersAndServices: {},
      timezones: [],
      itemtypes: [],
      carrierService: null,
      senderAddressSearch: null,
      receiverAddressSearch: null,
      newConsignmentInput: ''
    }
  },
  computed: {
    isAccountTeamCarrierServiceSet () {
      return !!this.$_.get(this.pickup.account, 'id') &&
      !!this.$_.get(this.pickup.team, 'id') &&
      !!this.$_.get(this.pickup.carrier, 'id') &&
      !!this.$_.get(this.pickup.carrier_service, 'id')
    },
    isConsignmentMode () {
      return !this.$_.isEmpty(this.pickup.consignments) || this.$_.isEmpty(this.pickup.items)
    }
  },
  created () {
    this.currentStatus = this.pickup.status

    this.loadLists()
    this.loadCarrierServices()
    this.setCountries()

    if (this.pickup.account) {
      this.accountInput = this.pickup.account.name
      this.remoteMethodCarrier(this.$_.get(this.pickup.carrier, 'name'))

      if (this.pickup.account.teams) {
        this.teams = this.pickup.account.teams
      }

      Array
        .from(
          new Set(
            this
              .$_
              .map(this.$_.get(this.pickup.account, 'carrier_service_settings', []), 'carrier_service.carrier.name')
          )
        )
        .map(carrier => {
          this
            .carriersAndServices[carrier] = this
              .$_
              .get(this.pickup.account, 'carrier_service_settings', [])
              .map(carrierServiceSetting => carrierServiceSetting.carrier_service.carrier.name === carrier ? carrierServiceSetting.carrier_service : undefined)
              .filter(carrierService => typeof carrierService !== 'undefined')
        })
    }
  },
  methods: {
    handleReceiverCountryChange () {
      this.states = []
    },
    loadLists () {
      this.isLoadingTimezones = true

      // Load Timezones
      this
        .$sdk
        .timezone
        .list(builder => {
          builder.page = 1
          builder.limit = 1000
          builder.order = 'default:asc'
        })
        .then(res => { this.timezones = res })
        .finally(() => { this.isLoadingTimezones = false })

      this.isLoadingItemtypes = true

      // Load Item Types
      this
        .$sdk
        .dictionary_itemtype
        .list(builder => {
          builder.page = 1
          builder.limit = 1000
          builder.order = 'uuid:asc'
        })
        .then(res => { this.itemtypes = res })
        .finally(() => { this.isLoadingItemtypes = false })
    },
    remoteMethodCarrier (query) {
      this.isLoadingCarriers = true

      this
        .$sdk
        .carrier
        .list(builder => {
          builder.filters = { 'carrier_name': query }
        })
        .then(res => { this.carriers = res })
        .finally(() => { this.isLoadingCarriers = false })
    },
    loadTeams () {
      if (this.pickup.account instanceof this.$sdk.account) {
        this.isLoadingTeams = true

        this
          .$sdk
          .team
          .list(builder => {
            builder.context = this.pickup.account
            builder.include = 'shipper_setting.address'
            builder.page = 1
            builder.limit = 100
            builder.order = 'name:asc'
          })
          .then(res => {
            this.teams = res

            if (this.teams.length === 1) {
              this.pickup.team = this.teams[0]
              this.onTeamChanged()
            }
          })
          .finally(() => { this.isLoadingTeams = false })
      }
    },
    loadCarrierServices () {
      if (this.pickup.carrier instanceof this.$sdk.carrier) {
        this.isLoadingCarrierServices = true

        this
          .$sdk
          .carrier_service
          .list(builder => {
            builder.context = this.pickup.carrier
            builder.page = 1
            builder.limit = 500
            builder.order = 'name:asc'
          })
          .then(res => { this.carrierServices = res.filter(service => !service.hide_from_pickups) })
          .finally(() => { this.isLoadingCarrierServices = false })
      }
    },
    accountQuerySearch (queryString, cb) {
      this
        .$sdk
        .account
        .list(builder => {
          builder.filters = { account_name: queryString, account_active: 1 }
          builder.include = [
            'carrier_service_settings.carrier_service.carrier',
            'carrier_service_settings.carrier_setting',
            'carrier_settings.carrier',
            'teams.shipper_setting.address'
          ]
        })
        .then(cb)
    },
    handleSelectAccount (account) {
      if (account instanceof this.$sdk.account) {
        this.accountInput = account.name
        this.teams = account.teams

        this.pickup.account = account
        this.pickup.team = null

        this.carriersAndServices = {}

        Array
          .from(
            new Set(
              this
                .$_
                .map(this.$_.get(account, 'carrier_service_settings', []), 'carrier_service.carrier.name')
            )
          )
          .map(carrier => {
            this
              .carriersAndServices[carrier] = this
                .$_
                .get(account, 'carrier_service_settings', [])
                .map(carrierServiceSetting => carrierServiceSetting.carrier_service.carrier.name === carrier && carrierServiceSetting.carrier_setting.carrier_active === true ? carrierServiceSetting.carrier_service : undefined)
                .filter(carrierService => typeof carrierService !== 'undefined')
          })

        if (this.teams.length === 1) {
          this.pickup.team = this.teams[0]
          this.onTeamChanged()
        }
      }
    },
    clearAccountInput () {
      this.accountInput = ''
      this.pickup.account = null
      this.pickup.team = null
      this.carrierService = null
    },
    addressQuerySearch (queryString, cb) {
      this
        .$sdk
        .account_address
        .list(builder => {
          const filters = [
            new Filter('name', CONTAINS, queryString)
          ]

          if (this.pickup.account) {
            filters.push(new Filter('account', IS, this.pickup.account.id))
          }

          if (this.pickup.account.parent) {
            filters.push(new Filter('account', IS, this.pickup.account.parent.id))
          }

          builder.filters = filters
          builder.order = 'name:asc'
        })
        .then(cb)
    },
    handleSenderAddressSelect (item) {
      this.pickup.sender.first_name = item.contact
      this.pickup.sender.last_name = ''
      this.pickup.sender.organisation_name = item.name
      this.pickup.sender.address_line1 = item.line_one
      this.pickup.sender.address_line2 = item.line_two
      this.pickup.sender.locality = item.suburb
      this.pickup.sender.administrative_area = item.state
      this.pickup.sender.postal_code = item.postcode
      this.pickup.sender.country = 'AU'
      this.pickup.sender.phone = item.phone
      this.pickup.sender.email = item.email
      this.pickup.special_instructions = item.spi || undefined
    },
    handleReceiverAddressSelect (item) {
      this.pickup.receiver.first_name = item.contact
      this.pickup.receiver.last_name = ''
      this.pickup.receiver.organisation_name = item.name
      this.pickup.receiver.address_line1 = item.line_one
      this.pickup.receiver.address_line2 = item.line_two
      this.pickup.receiver.locality = item.suburb
      this.pickup.receiver.administrative_area = item.state
      this.pickup.receiver.postal_code = item.postcode
      this.pickup.receiver.country = 'AU'
      this.pickup.receiver.phone = item.phone
      this.pickup.receiver.email = item.email
    },
    async suburbSenderQuerySearch (queryString, cb) {
      this
        .$sdk
        .location
        .list(builder => {
          const filters = [
            new Filter('country', IS, this.pickup.sender.country),
            new Filter('query', IS, queryString)
          ]
          builder.filters = filters
          builder.page = 1
          builder.limit = 50
          builder.order = 'suburb:asc'
        })
        .then(cb)
    },
    async suburbReceiverQuerySearch (queryString, cb) {
      this
        .$sdk
        .location
        .list(builder => {
          const filters = [
            new Filter('country', IS, this.pickup.receiver.country),
            new Filter('query', IS, queryString)
          ]
          builder.filters = filters
          builder.page = 1
          builder.limit = 50
          builder.order = 'suburb:asc'
        })
        .then(cb)
    },
    handleSenderSuburbSelect (item) {
      this.pickup.sender.locality = item.suburb
      this.pickup.sender.administrative_area = item.state
      this.pickup.sender.postal_code = item.postcode
    },
    handleReceiverSuburbSelect (item) {
      this.pickup.receiver.locality = item.suburb
      this.pickup.receiver.administrative_area = item.state
      this.pickup.receiver.postal_code = item.postcode
    },
    onTeamChanged () {
      this.tryAndSetSender()

      if (!this.isScheduleTemplate) {
        this.tryAndSetClosingTime()
      }

      this.tryAndSetTimezone()
      this.tryAndSetChargeAccount()
      this.tryAndSetCutOff()
    },
    onCarrierAndServiceSelected () {
      this.pickup.carrier = this.carrierService.carrier.clone()
      this.pickup.carrier_service = this.carrierService.clone()
      this.carriers = [ this.carrierService.carrier.clone() ]
      this.carrierServices = [ this.carrierService.clone() ]
      this.onCarrierServiceChanged()
      this.loadCarrierServices()
      this.carrierService = undefined
    },
    onCarrierChanged () {
      this.pickup.carrier_service = null

      if (this.pickup.carrier instanceof this.$sdk.carrier) {
        this.loadCarrierServices()
      }
    },
    onCarrierServiceChanged () {
      this.tryAndSetChargeAccount()
      this.tryAndSetCutOff()
    },
    tryAndSetSender () {
      if (this.$_.get(this.pickup.team, 'shipper_setting.address')) {
        let teamAddress = this.pickup.team.shipper_setting.address

        this.pickup.sender.first_name = teamAddress.contact
        this.pickup.sender.last_name = ''
        this.pickup.sender.organisation_name = teamAddress.name
        this.pickup.sender.address_line1 = teamAddress.address_1
        this.pickup.sender.address_line2 = teamAddress.address_2
        this.pickup.sender.locality = teamAddress.suburb
        this.pickup.sender.administrative_area = teamAddress.state
        this.pickup.sender.postal_code = teamAddress.postcode
        this.pickup.sender.country = teamAddress.country || 'AU'
        this.pickup.sender.phone = teamAddress.phone
        this.pickup.sender.email = teamAddress.email

        this.pickup.collection_name = teamAddress.name
      } else if (this.pickup.account instanceof this.$sdk.account) {
        this.pickup.sender.first_name = this.pickup.account.contact
        this.pickup.sender.last_name = ''
        this.pickup.sender.organisation_name = this.pickup.account.name
        this.pickup.sender.address_line1 = this.pickup.account.address
        this.pickup.sender.address_line2 = ''
        this.pickup.sender.locality = this.pickup.account.suburb
        this.pickup.sender.administrative_area = this.pickup.account.state
        this.pickup.sender.postal_code = this.pickup.account.postcode
        this.pickup.sender.country = 'AU'
        this.pickup.sender.phone = this.pickup.account.phone
        this.pickup.sender.email = this.pickup.account.email

        this.pickup.collection_name = this.pickup.account.name
      }
    },
    tryAndSetClosingTime () {
      if (this.pickup.account && this.pickup.account.shipper_closing_time) {
        this.pickup.customer_closing_time = this.$moment(this.pickup.account.shipper_closing_time).format('HH:mm')
      }
    },
    tryAndSetTimezone () {
      let postcode = null

      if (this.pickup.team && this.pickup.team.shipper_setting && this.pickup.team.shipper_setting.address) {
        postcode = this.pickup.team.shipper_setting.address.postcode
      } else if (this.pickup.account && this.pickup.account.postcode) {
        postcode = this.pickup.account.postcode
      }

      if (postcode) {
        let find

        switch (String(postcode)[0]) {
          case '2':
            find = 'Australia/Sydney'
            break
          case '3':
            find = 'Australia/Melbourne'
            break
          case '4':
            find = 'Australia/Brisbane'
            break
          case '5':
            find = 'Australia/Adelaide'
            break
          case '6':
            find = 'Australia/Perth'
            break
          case '7':
            find = 'Australia/Hobart'
            break
          case '0':
            find = 'Australia/Darwin'
            break
          default:
            find = 'Australia/Melbourne'
            break
        }

        this.pickup.customer_time_zone = this.timezones.find(t => t.zone === find)
      }
    },
    tryAndSetChargeAccount () {
      if (this.isAccountTeamCarrierServiceSet) {
        const found = this.pickup.account.carrier_settings.find(cs => cs.carrier.id === this.pickup.carrier.id)
        this.pickup.charge_account = found ? found.charge_account : ''
      }
    },
    tryAndSetCutOff () {
      if (this.isAccountTeamCarrierServiceSet) {
        const original = this.pickup.carrier.pickup_cutoff

        if (original) {
          const cutOff = this.$moment()

          cutOff.set('hour', original)
          cutOff.set('minute', 0)
          cutOff.set('second', 0)

          this.pickup.carrier_cut_off_time = cutOff.format('HH:mm')
        }
      }
    },
    setVarious () {
      this.pickup.receiver = Object.assign(new this.$sdk.address(), {
        organisation_name: 'VARIOUS',
        address_line1: 'VARIOUS',
        locality: 'NO SUBURB',
        administrative_area: 'Other',
        postal_code: '0000',
        country: 'AU'
      })
    },
    swapSenderReceiver () {
      const senderTemp = this.pickup.sender.clone()
      const receiverTemp = this.pickup.receiver.clone()

      this.pickup.sender = receiverTemp
      this.pickup.receiver = senderTemp
    },
    addNewItem () {
      this.pickup.items.push(new this.$sdk.pickup_item())
    },
    consignmentQuerySearch (queryString, cb) {
      this
        .$sdk
        .consignment
        .list(builder => {
          builder.include = ['items']
          builder.filters = { consignment_con_full: queryString }
          builder.page = 1
          builder.limit = 20
          builder.order = 'uuid:asc'
        })
        .then(cb)
    },
    handleSelectConsignment (item) {
      this.pickup.consignments.push(item)
      this.newConsignmentInput = ''
    },
    removeConsignmentByIndex (index) {
      this.pickup.consignments.splice(index, 1)
    },
    convertConsignmentItems () {
      const itemsTemp = (this.pickup.consignments.map(c => c.items)).flat()
      const newItemsTemp = []

      itemsTemp
        .map(item => newItemsTemp.push(this.convertConsignmentItemToItem(item)))

      this.pickup.consignments.splice(0, this.pickup.consignments.length)
      this.pickup.items = newItemsTemp
    },
    convertConsignmentItemToItem (consignmentItem) {
      return {
        description: consignmentItem.item_desc || '',
        pallet_count: 0,
        item_count: consignmentItem.item_qty || 0,
        length: consignmentItem.item_length || 0,
        width: consignmentItem.item_width || 0,
        height: consignmentItem.item_height || 0,
        largest_length: 0,
        weight: consignmentItem.item_weight || 0,
        is_dg: false,
        type: consignmentItem.type
      }
    },
    isStatusAllows (from, to) {
      return statusAllows(from, to)
    },
    hasConsignmentOrItem () {
      if (this.pickup.consignments.length > 0 || this.pickup.items.length > 0) {
        return true
      } else {
        this.$message.error('At least one item or consignment must be declared')
        return false
      }
    },
    handleItemTypeSelection (item) {
      if (item.type) {
        item.description = item.type.desc
      }
    },
    setCountries () {
      this.countries = [
        {
          'name': 'Afghanistan',
          'iso': 'AF',
          'country-code': '004'
        },
        {
          'name': 'Aland Islands',
          'iso': 'AX',
          'country-code': '248'
        },
        {
          'name': 'Albania',
          'iso': 'AL',
          'country-code': '008'
        },
        {
          'name': 'Algeria',
          'iso': 'DZ',
          'country-code': '012'
        },
        {
          'name': 'American Samoa',
          'iso': 'AS',
          'country-code': '016'
        },
        {
          'name': 'Andorra',
          'iso': 'AD',
          'country-code': '020'
        },
        {
          'name': 'Angola',
          'iso': 'AO',
          'country-code': '024'
        },
        {
          'name': 'Anguilla',
          'iso': 'AI',
          'country-code': '660'
        },
        {
          'name': 'Antarctica',
          'iso': 'AQ',
          'country-code': '010'
        },
        {
          'name': 'Antigua and Barbuda',
          'iso': 'AG',
          'country-code': '028'
        },
        {
          'name': 'Argentina',
          'iso': 'AR',
          'country-code': '032'
        },
        {
          'name': 'Armenia',
          'iso': 'AM',
          'country-code': '051'
        },
        {
          'name': 'Aruba',
          'iso': 'AW',
          'country-code': '533'
        },
        {
          'name': 'Australia',
          'iso': 'AU',
          'country-code': '036'
        },
        {
          'name': 'Austria',
          'iso': 'AT',
          'country-code': '040'
        },
        {
          'name': 'Azerbaijan',
          'iso': 'AZ',
          'country-code': '031'
        },
        {
          'name': 'Bahamas',
          'iso': 'BS',
          'country-code': '044'
        },
        {
          'name': 'Bahrain',
          'iso': 'BH',
          'country-code': '048'
        },
        {
          'name': 'Bangladesh',
          'iso': 'BD',
          'country-code': '050'
        },
        {
          'name': 'Barbados',
          'iso': 'BB',
          'country-code': '052'
        },
        {
          'name': 'Belarus',
          'iso': 'BY',
          'country-code': '112'
        },
        {
          'name': 'Belgium',
          'iso': 'BE',
          'country-code': '056'
        },
        {
          'name': 'Belize',
          'iso': 'BZ',
          'country-code': '084'
        },
        {
          'name': 'Benin',
          'iso': 'BJ',
          'country-code': '204'
        },
        {
          'name': 'Bermuda',
          'iso': 'BM',
          'country-code': '060'
        },
        {
          'name': 'Bhutan',
          'iso': 'BT',
          'country-code': '064'
        },
        {
          'name': 'Bolivia (Plurinational State of)',
          'iso': 'BO',
          'country-code': '068'
        },
        {
          'name': 'Bonaire, Sint Eustatius and Saba',
          'iso': 'BQ',
          'country-code': '535'
        },
        {
          'name': 'Bosnia and Herzegovina',
          'iso': 'BA',
          'country-code': '070'
        },
        {
          'name': 'Botswana',
          'iso': 'BW',
          'country-code': '072'
        },
        {
          'name': 'Bouvet Island',
          'iso': 'BV',
          'country-code': '074'
        },
        {
          'name': 'Brazil',
          'iso': 'BR',
          'country-code': '076'
        },
        {
          'name': 'British Indian Ocean Territory',
          'iso': 'IO',
          'country-code': '086'
        },
        {
          'name': 'Brunei Darussalam',
          'iso': 'BN',
          'country-code': '096'
        },
        {
          'name': 'Bulgaria',
          'iso': 'BG',
          'country-code': '100'
        },
        {
          'name': 'Burkina Faso',
          'iso': 'BF',
          'country-code': '854'
        },
        {
          'name': 'Burundi',
          'iso': 'BI',
          'country-code': '108'
        },
        {
          'name': 'Cabo Verde',
          'iso': 'CV',
          'country-code': '132'
        },
        {
          'name': 'Cambodia',
          'iso': 'KH',
          'country-code': '116'
        },
        {
          'name': 'Cameroon',
          'iso': 'CM',
          'country-code': '120'
        },
        {
          'name': 'Canada',
          'iso': 'CA',
          'country-code': '124'
        },
        {
          'name': 'Cayman Islands',
          'iso': 'KY',
          'country-code': '136'
        },
        {
          'name': 'Central African Republic',
          'iso': 'CF',
          'country-code': '140'
        },
        {
          'name': 'Chad',
          'iso': 'TD',
          'country-code': '148'
        },
        {
          'name': 'Chile',
          'iso': 'CL',
          'country-code': '152'
        },
        {
          'name': 'China',
          'iso': 'CN',
          'country-code': '156'
        },
        {
          'name': 'Christmas Island',
          'iso': 'CX',
          'country-code': '162'
        },
        {
          'name': 'Cocos (Keeling) Islands',
          'iso': 'CC',
          'country-code': '166'
        },
        {
          'name': 'Colombia',
          'iso': 'CO',
          'country-code': '170'
        },
        {
          'name': 'Comoros',
          'iso': 'KM',
          'country-code': '174'
        },
        {
          'name': 'Congo',
          'iso': 'CG',
          'country-code': '178'
        },
        {
          'name': 'Congo, Democratic Republic of the',
          'iso': 'CD',
          'country-code': '180'
        },
        {
          'name': 'Cook Islands',
          'iso': 'CK',
          'country-code': '184'
        },
        {
          'name': 'Costa Rica',
          'iso': 'CR',
          'country-code': '188'
        },
        {
          'name': 'Côte dIvoire',
          'iso': 'CI',
          'country-code': '384'
        },
        {
          'name': 'Croatia',
          'iso': 'HR',
          'country-code': '191'
        },
        {
          'name': 'Cuba',
          'iso': 'CU',
          'country-code': '192'
        },
        {
          'name': 'Curaçao',
          'iso': 'CW',
          'country-code': '531'
        },
        {
          'name': 'Cyprus',
          'iso': 'CY',
          'country-code': '196'
        },
        {
          'name': 'Czechia',
          'iso': 'CZ',
          'country-code': '203'
        },
        {
          'name': 'Denmark',
          'iso': 'DK',
          'country-code': '208'
        },
        {
          'name': 'Djibouti',
          'iso': 'DJ',
          'country-code': '262'
        },
        {
          'name': 'Dominica',
          'iso': 'DM',
          'country-code': '212'
        },
        {
          'name': 'Dominican Republic',
          'iso': 'DO',
          'country-code': '214'
        },
        {
          'name': 'Ecuador',
          'iso': 'EC',
          'country-code': '218'
        },
        {
          'name': 'Egypt',
          'iso': 'EG',
          'country-code': '818'
        },
        {
          'name': 'El Salvador',
          'iso': 'SV',
          'country-code': '222'
        },
        {
          'name': 'Equatorial Guinea',
          'iso': 'GQ',
          'country-code': '226'
        },
        {
          'name': 'Eritrea',
          'iso': 'ER',
          'country-code': '232'
        },
        {
          'name': 'Estonia',
          'iso': 'EE',
          'country-code': '233'
        },
        {
          'name': 'Eswatini',
          'iso': 'SZ',
          'country-code': '748'
        },
        {
          'name': 'Ethiopia',
          'iso': 'ET',
          'country-code': '231'
        },
        {
          'name': 'Falkland Islands (Malvinas)',
          'iso': 'FK',
          'country-code': '238'
        },
        {
          'name': 'Faroe Islands',
          'iso': 'FO',
          'country-code': '234'
        },
        {
          'name': 'Fiji',
          'iso': 'FJ',
          'country-code': '242'
        },
        {
          'name': 'Finland',
          'iso': 'FI',
          'country-code': '246'
        },
        {
          'name': 'France',
          'iso': 'FR',
          'country-code': '250'
        },
        {
          'name': 'French Guiana',
          'iso': 'GF',
          'country-code': '254'
        },
        {
          'name': 'French Polynesia',
          'iso': 'PF',
          'country-code': '258'
        },
        {
          'name': 'French Southern Territories',
          'iso': 'TF',
          'country-code': '260'
        },
        {
          'name': 'Gabon',
          'iso': 'GA',
          'country-code': '266'
        },
        {
          'name': 'Gambia',
          'iso': 'GM',
          'country-code': '270'
        },
        {
          'name': 'Georgia',
          'iso': 'GE',
          'country-code': '268'
        },
        {
          'name': 'Germany',
          'iso': 'DE',
          'country-code': '276'
        },
        {
          'name': 'Ghana',
          'iso': 'GH',
          'country-code': '288'
        },
        {
          'name': 'Gibraltar',
          'iso': 'GI',
          'country-code': '292'
        },
        {
          'name': 'Greece',
          'iso': 'GR',
          'country-code': '300'
        },
        {
          'name': 'Greenland',
          'iso': 'GL',
          'country-code': '304'
        },
        {
          'name': 'Grenada',
          'iso': 'GD',
          'country-code': '308'
        },
        {
          'name': 'Guadeloupe',
          'iso': 'GP',
          'country-code': '312'
        },
        {
          'name': 'Guam',
          'iso': 'GU',
          'country-code': '316'
        },
        {
          'name': 'Guatemala',
          'iso': 'GT',
          'country-code': '320'
        },
        {
          'name': 'Guernsey',
          'iso': 'GG',
          'country-code': '831'
        },
        {
          'name': 'Guinea',
          'iso': 'GN',
          'country-code': '324'
        },
        {
          'name': 'Guinea-Bissau',
          'iso': 'GW',
          'country-code': '624'
        },
        {
          'name': 'Guyana',
          'iso': 'GY',
          'country-code': '328'
        },
        {
          'name': 'Haiti',
          'iso': 'HT',
          'country-code': '332'
        },
        {
          'name': 'Heard Island and McDonald Islands',
          'iso': 'HM',
          'country-code': '334'
        },
        {
          'name': 'Holy See',
          'iso': 'VA',
          'country-code': '336'
        },
        {
          'name': 'Honduras',
          'iso': 'HN',
          'country-code': '340'
        },
        {
          'name': 'Hong Kong',
          'iso': 'HK',
          'country-code': '344'
        },
        {
          'name': 'Hungary',
          'iso': 'HU',
          'country-code': '348'
        },
        {
          'name': 'Iceland',
          'iso': 'IS',
          'country-code': '352'
        },
        {
          'name': 'India',
          'iso': 'IN',
          'country-code': '356'
        },
        {
          'name': 'Indonesia',
          'iso': 'ID',
          'country-code': '360'
        },
        {
          'name': 'Iran (Islamic Republic of)',
          'iso': 'IR',
          'country-code': '364'
        },
        {
          'name': 'Iraq',
          'iso': 'IQ',
          'country-code': '368'
        },
        {
          'name': 'Ireland',
          'iso': 'IE',
          'country-code': '372'
        },
        {
          'name': 'Isle of Man',
          'iso': 'IM',
          'country-code': '833'
        },
        {
          'name': 'Israel',
          'iso': 'IL',
          'country-code': '376'
        },
        {
          'name': 'Italy',
          'iso': 'IT',
          'country-code': '380'
        },
        {
          'name': 'Jamaica',
          'iso': 'JM',
          'country-code': '388'
        },
        {
          'name': 'Japan',
          'iso': 'JP',
          'country-code': '392'
        },
        {
          'name': 'Jersey',
          'iso': 'JE',
          'country-code': '832'
        },
        {
          'name': 'Jordan',
          'iso': 'JO',
          'country-code': '400'
        },
        {
          'name': 'Kazakhstan',
          'iso': 'KZ',
          'country-code': '398'
        },
        {
          'name': 'Kenya',
          'iso': 'KE',
          'country-code': '404'
        },
        {
          'name': 'Kiribati',
          'iso': 'KI',
          'country-code': '296'
        },
        {
          'name': 'Korea (Democratic Peoples Republic of)',
          'iso': 'KP',
          'country-code': '408'
        },
        {
          'name': 'Korea, Republic of',
          'iso': 'KR',
          'country-code': '410'
        },
        {
          'name': 'Kuwait',
          'iso': 'KW',
          'country-code': '414'
        },
        {
          'name': 'Kyrgyzstan',
          'iso': 'KG',
          'country-code': '417'
        },
        {
          'name': 'Lao Peoples Democratic Republic',
          'iso': 'LA',
          'country-code': '418'
        },
        {
          'name': 'Latvia',
          'iso': 'LV',
          'country-code': '428'
        },
        {
          'name': 'Lebanon',
          'iso': 'LB',
          'country-code': '422'
        },
        {
          'name': 'Lesotho',
          'iso': 'LS',
          'country-code': '426'
        },
        {
          'name': 'Liberia',
          'iso': 'LR',
          'country-code': '430'
        },
        {
          'name': 'Libya',
          'iso': 'LY',
          'country-code': '434'
        },
        {
          'name': 'Liechtenstein',
          'iso': 'LI',
          'country-code': '438'
        },
        {
          'name': 'Lithuania',
          'iso': 'LT',
          'country-code': '440'
        },
        {
          'name': 'Luxembourg',
          'iso': 'LU',
          'country-code': '442'
        },
        {
          'name': 'Macao',
          'iso': 'MO',
          'country-code': '446'
        },
        {
          'name': 'Madagascar',
          'iso': 'MG',
          'country-code': '450'
        },
        {
          'name': 'Malawi',
          'iso': 'MW',
          'country-code': '454'
        },
        {
          'name': 'Malaysia',
          'iso': 'MY',
          'country-code': '458'
        },
        {
          'name': 'Maldives',
          'iso': 'MV',
          'country-code': '462'
        },
        {
          'name': 'Mali',
          'iso': 'ML',
          'country-code': '466'
        },
        {
          'name': 'Malta',
          'iso': 'MT',
          'country-code': '470'
        },
        {
          'name': 'Marshall Islands',
          'iso': 'MH',
          'country-code': '584'
        },
        {
          'name': 'Martinique',
          'iso': 'MQ',
          'country-code': '474'
        },
        {
          'name': 'Mauritania',
          'iso': 'MR',
          'country-code': '478'
        },
        {
          'name': 'Mauritius',
          'iso': 'MU',
          'country-code': '480'
        },
        {
          'name': 'Mayotte',
          'iso': 'YT',
          'country-code': '175'
        },
        {
          'name': 'Mexico',
          'iso': 'MX',
          'country-code': '484'
        },
        {
          'name': 'Micronesia (Federated States of)',
          'iso': 'FM',
          'country-code': '583'
        },
        {
          'name': 'Moldova, Republic of',
          'iso': 'MD',
          'country-code': '498'
        },
        {
          'name': 'Monaco',
          'iso': 'MC',
          'country-code': '492'
        },
        {
          'name': 'Mongolia',
          'iso': 'MN',
          'country-code': '496'
        },
        {
          'name': 'Montenegro',
          'iso': 'ME',
          'country-code': '499'
        },
        {
          'name': 'Montserrat',
          'iso': 'MS',
          'country-code': '500'
        },
        {
          'name': 'Morocco',
          'iso': 'MA',
          'country-code': '504'
        },
        {
          'name': 'Mozambique',
          'iso': 'MZ',
          'country-code': '508'
        },
        {
          'name': 'Myanmar',
          'iso': 'MM',
          'country-code': '104'
        },
        {
          'name': 'Namibia',
          'iso': 'NA',
          'country-code': '516'
        },
        {
          'name': 'Nauru',
          'iso': 'NR',
          'country-code': '520'
        },
        {
          'name': 'Nepal',
          'iso': 'NP',
          'country-code': '524'
        },
        {
          'name': 'Netherlands',
          'iso': 'NL',
          'country-code': '528'
        },
        {
          'name': 'New Caledonia',
          'iso': 'NC',
          'country-code': '540'
        },
        {
          'name': 'New Zealand',
          'iso': 'NZ',
          'country-code': '554'
        },
        {
          'name': 'Nicaragua',
          'iso': 'NI',
          'country-code': '558'
        },
        {
          'name': 'Niger',
          'iso': 'NE',
          'country-code': '562'
        },
        {
          'name': 'Nigeria',
          'iso': 'NG',
          'country-code': '566'
        },
        {
          'name': 'Niue',
          'iso': 'NU',
          'country-code': '570'
        },
        {
          'name': 'Norfolk Island',
          'iso': 'NF',
          'country-code': '574'
        },
        {
          'name': 'North Macedonia',
          'iso': 'MK',
          'country-code': '807'
        },
        {
          'name': 'Northern Mariana Islands',
          'iso': 'MP',
          'country-code': '580'
        },
        {
          'name': 'Norway',
          'iso': 'NO',
          'country-code': '578'
        },
        {
          'name': 'Oman',
          'iso': 'OM',
          'country-code': '512'
        },
        {
          'name': 'Pakistan',
          'iso': 'PK',
          'country-code': '586'
        },
        {
          'name': 'Palau',
          'iso': 'PW',
          'country-code': '585'
        },
        {
          'name': 'Palestine, State of',
          'iso': 'PS',
          'country-code': '275'
        },
        {
          'name': 'Panama',
          'iso': 'PA',
          'country-code': '591'
        },
        {
          'name': 'Papua New Guinea',
          'iso': 'PG',
          'country-code': '598'
        },
        {
          'name': 'Paraguay',
          'iso': 'PY',
          'country-code': '600'
        },
        {
          'name': 'Peru',
          'iso': 'PE',
          'country-code': '604'
        },
        {
          'name': 'Philippines',
          'iso': 'PH',
          'country-code': '608'
        },
        {
          'name': 'Pitcairn',
          'iso': 'PN',
          'country-code': '612'
        },
        {
          'name': 'Poland',
          'iso': 'PL',
          'country-code': '616'
        },
        {
          'name': 'Portugal',
          'iso': 'PT',
          'country-code': '620'
        },
        {
          'name': 'Puerto Rico',
          'iso': 'PR',
          'country-code': '630'
        },
        {
          'name': 'Qatar',
          'iso': 'QA',
          'country-code': '634'
        },
        {
          'name': 'Réunion',
          'iso': 'RE',
          'country-code': '638'
        },
        {
          'name': 'Romania',
          'iso': 'RO',
          'country-code': '642'
        },
        {
          'name': 'Russian Federation',
          'iso': 'RU',
          'country-code': '643'
        },
        {
          'name': 'Rwanda',
          'iso': 'RW',
          'country-code': '646'
        },
        {
          'name': 'Saint Barthélemy',
          'iso': 'BL',
          'country-code': '652'
        },
        {
          'name': 'Saint Helena, Ascension and Tristan da Cunha',
          'iso': 'SH',
          'country-code': '654'
        },
        {
          'name': 'Saint Kitts and Nevis',
          'iso': 'KN',
          'country-code': '659'
        },
        {
          'name': 'Saint Lucia',
          'iso': 'LC',
          'country-code': '662'
        },
        {
          'name': 'Saint Martin (French part)',
          'iso': 'MF',
          'country-code': '663'
        },
        {
          'name': 'Saint Pierre and Miquelon',
          'iso': 'PM',
          'country-code': '666'
        },
        {
          'name': 'Saint Vincent and the Grenadines',
          'iso': 'VC',
          'country-code': '670'
        },
        {
          'name': 'Samoa',
          'iso': 'WS',
          'country-code': '882'
        },
        {
          'name': 'San Marino',
          'iso': 'SM',
          'country-code': '674'
        },
        {
          'name': 'Sao Tome and Principe',
          'iso': 'ST',
          'country-code': '678'
        },
        {
          'name': 'Saudi Arabia',
          'iso': 'SA',
          'country-code': '682'
        },
        {
          'name': 'Senegal',
          'iso': 'SN',
          'country-code': '686'
        },
        {
          'name': 'Serbia',
          'iso': 'RS',
          'country-code': '688'
        },
        {
          'name': 'Seychelles',
          'iso': 'SC',
          'country-code': '690'
        },
        {
          'name': 'Sierra Leone',
          'iso': 'SL',
          'country-code': '694'
        },
        {
          'name': 'Singapore',
          'iso': 'SG',
          'country-code': '702'
        },
        {
          'name': 'Sint Maarten (Dutch part)',
          'iso': 'SX',
          'country-code': '534'
        },
        {
          'name': 'Slovakia',
          'iso': 'SK',
          'country-code': '703'
        },
        {
          'name': 'Slovenia',
          'iso': 'SI',
          'country-code': '705'
        },
        {
          'name': 'Solomon Islands',
          'iso': 'SB',
          'country-code': '090'
        },
        {
          'name': 'Somalia',
          'iso': 'SO',
          'country-code': '706'
        },
        {
          'name': 'South Africa',
          'iso': 'ZA',
          'country-code': '710'
        },
        {
          'name': 'South Georgia and the South Sandwich Islands',
          'iso': 'GS',
          'country-code': '239'
        },
        {
          'name': 'South Sudan',
          'iso': 'SS',
          'country-code': '728'
        },
        {
          'name': 'Spain',
          'iso': 'ES',
          'country-code': '724'
        },
        {
          'name': 'Sri Lanka',
          'iso': 'LK',
          'country-code': '144'
        },
        {
          'name': 'Sudan',
          'iso': 'SD',
          'country-code': '729'
        },
        {
          'name': 'Suriname',
          'iso': 'SR',
          'country-code': '740'
        },
        {
          'name': 'Svalbard and Jan Mayen',
          'iso': 'SJ',
          'country-code': '744'
        },
        {
          'name': 'Sweden',
          'iso': 'SE',
          'country-code': '752'
        },
        {
          'name': 'Switzerland',
          'iso': 'CH',
          'country-code': '756'
        },
        {
          'name': 'Syrian Arab Republic',
          'iso': 'SY',
          'country-code': '760'
        },
        {
          'name': 'Taiwan, Province of China',
          'iso': 'TW',
          'country-code': '158'
        },
        {
          'name': 'Tajikistan',
          'iso': 'TJ',
          'country-code': '762'
        },
        {
          'name': 'Tanzania, United Republic of',
          'iso': 'TZ',
          'country-code': '834'
        },
        {
          'name': 'Thailand',
          'iso': 'TH',
          'country-code': '764'
        },
        {
          'name': 'Timor-Leste',
          'iso': 'TL',
          'country-code': '626'
        },
        {
          'name': 'Togo',
          'iso': 'TG',
          'country-code': '768'
        },
        {
          'name': 'Tokelau',
          'iso': 'TK',
          'country-code': '772'
        },
        {
          'name': 'Tonga',
          'iso': 'TO',
          'country-code': '776'
        },
        {
          'name': 'Trinidad and Tobago',
          'iso': 'TT',
          'country-code': '780'
        },
        {
          'name': 'Tunisia',
          'iso': 'TN',
          'country-code': '788'
        },
        {
          'name': 'Turkey',
          'iso': 'TR',
          'country-code': '792'
        },
        {
          'name': 'Turkmenistan',
          'iso': 'TM',
          'country-code': '795'
        },
        {
          'name': 'Turks and Caicos Islands',
          'iso': 'TC',
          'country-code': '796'
        },
        {
          'name': 'Tuvalu',
          'iso': 'TV',
          'country-code': '798'
        },
        {
          'name': 'Uganda',
          'iso': 'UG',
          'country-code': '800'
        },
        {
          'name': 'Ukraine',
          'iso': 'UA',
          'country-code': '804'
        },
        {
          'name': 'United Arab Emirates',
          'iso': 'AE',
          'country-code': '784'
        },
        {
          'name': 'United Kingdom of Great Britain and Northern Ireland',
          'iso': 'GB',
          'country-code': '826'
        },
        {
          'name': 'United States of America',
          'iso': 'US',
          'country-code': '840'
        },
        {
          'name': 'United States Minor Outlying Islands',
          'iso': 'UM',
          'country-code': '581'
        },
        {
          'name': 'Uruguay',
          'iso': 'UY',
          'country-code': '858'
        },
        {
          'name': 'Uzbekistan',
          'iso': 'UZ',
          'country-code': '860'
        },
        {
          'name': 'Vanuatu',
          'iso': 'VU',
          'country-code': '548'
        },
        {
          'name': 'Venezuela (Bolivarian Republic of)',
          'iso': 'VE',
          'country-code': '862'
        },
        {
          'name': 'Viet Nam',
          'iso': 'VN',
          'country-code': '704'
        },
        {
          'name': 'Virgin Islands (British)',
          'iso': 'VG',
          'country-code': '092'
        },
        {
          'name': 'Virgin Islands (U.S.)',
          'iso': 'VI',
          'country-code': '850'
        },
        {
          'name': 'Wallis and Futuna',
          'iso': 'WF',
          'country-code': '876'
        },
        {
          'name': 'Western Sahara',
          'iso': 'EH',
          'country-code': '732'
        },
        {
          'name': 'Yemen',
          'iso': 'YE',
          'country-code': '887'
        },
        {
          'name': 'Zambia',
          'iso': 'ZM',
          'country-code': '894'
        },
        {
          'name': 'Zimbabwe',
          'iso': 'ZW',
          'country-code': '716'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.one-ninth {
  width: 11.1%;
}

::v-deep .el-form-item--mini .el-form-item__label {
  font-size: 12px;
  padding: 0;
}

::v-deep .el-form-item--mini .el-form-item__error {
  padding-top: 4px;
  position: unset;
  line-height: 1.35;
}

.items-container {
  ::v-deep .el-form-item--mini.el-form-item > div {
    margin-left: 0px !important;
  }
}

.consignments-container {
  ::v-deep .el-divider--horizontal {
    margin: 10px 0px;
  }
}
</style>
